
import * as type from './types';

export function getMyworks(data) {
    return {
        type: type.GET_MY_WORKS_REQUESTED,
        data: data,
    }
};